"use client";

import { createContext, useContext } from "react";

/**
 * Switches the hero to another article client-side (no RSC navigation).
 * `href` is the variant's canonical URL, used to keep the address bar shareable.
 */
export type VariantSwitchHandler = (articleCode: string, href?: string) => void;

const VariantSwitchContext = createContext<VariantSwitchHandler | undefined>(
  undefined
);

export const VariantSwitchProvider = VariantSwitchContext.Provider;

/**
 * Returns the current hero's switch handler, or `undefined` when a selector is
 * rendered outside a {@link VariantSwitchProvider} (then it falls back to
 * normal link navigation).
 */
export function useVariantSwitch(): VariantSwitchHandler | undefined {
  return useContext(VariantSwitchContext);
}
